import { Loading } from '@/commons/components';
import { SLUGS } from '@/commons/constants/slugs';
import loadable from '@loadable/component';
import { ComponentType } from 'react';

interface LoadableRoutesType {
  [key: string]: {
    component: React.ComponentType;
    exact?: boolean;
    permissions?: string[];
  };
}

const loadableComponent = (
  loader: () => Promise<ComponentType<any> | { default: ComponentType<any> }>
) => loadable(loader, { fallback: <Loading /> });

const loadableRoutes: LoadableRoutesType = {
  // Dashboard
  '/': {
    component: loadableComponent(() => import('../pages/Dashboard')),
  },
  [SLUGS.DASHBOARD]: {
    component: loadableComponent(() => import('../pages/Dashboard')),
  },

  // Showroom
  [SLUGS.SHOWROOMS_MANAGEMENT]: {
    component: loadableComponent(() => import('../pages/ShowroomManagement')),
  },
  [SLUGS.SHOWROOMS_DETAIL]: {
    component: loadableComponent(() => import('../pages/ShowroomManagement/ShowroomDetail')),
  },

  // Product
  [SLUGS.PRODUCTS_MANAGEMENT]: {
    component: loadableComponent(() => import('../pages/ProductManagement')),
  },
  [SLUGS.PRODUCTS_DETAIL]: {
    component: loadableComponent(() => import('../pages/ProductManagement/ProductDetail')),
  },

  // Brand
  [SLUGS.BRANDS_MANAGEMENT]: {
    component: loadableComponent(() => import('../pages/Brand')),
  },

  // Agent
  [SLUGS.AGENTS_MANAGEMENT]: {
    component: loadableComponent(() => import('../pages/AgentManagement')),
  },
  [SLUGS.AGENTS_DETAIL]: {
    component: loadableComponent(() => import('../pages/AgentManagement/AgentDetail')),
  },
};

export default loadableRoutes;
